export default "__VITE_ASSET__BFca6I46__"